<div class="container login-form-ui">
  <div class="row w-100 mx-0 auth-page">
    <div class="col-md-8 col-xl-6 mx-auto">
      <div class="card">
        <div class="row">
          <div class="col-md-4 pe-md-0">
            <div class="auth-side-wrapper">

            </div>
          </div>
          <div class="col-md-8 ps-md-0">
            <div class="auth-form-wrapper px-4 py-5">
              <a routerLink="." class="coh-logo d-block mb-2">
                <span class="coh-logo-text">Flint Housing</span>
                <span class="coh-tagline">Customer Care</span>
              </a>
              <h5 class="text-secondary fw-normal mb-4">Forgot Password</h5>
              <form [formGroup]="emailForm" class="forms-sample">
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label">Email Address</label>
                  <input type="email" class="form-control" id="email" name="email" placeholder="Enter your email"
                    formControlName="email">
                </div>
                <div>
                  <button type="submit" class="btn btn-primary me-2 mb-2 mb-md-0" (click)="submitEmail()">Send</button>
                  <button type="submit" class="btn btn-primary me-2 mb-2 mb-md-0" (click)="cancelEmail()">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>